import { mode } from '@chakra-ui/theme-tools';

export const buttonStyles = {
  components: {
    Button: {
      baseStyle: {
        borderRadius: '8px',
        fontWeight: '600',
        transition: 'all 0.2s ease-in-out',
        _focus: {
          boxShadow: 'none',
        },
      },
      variants: {
        solid: (props: any) => {
          const { colorScheme: c } = props;
          if (c === 'brand') {
            return {
              bg: 'brand.500',
              color: 'white',
              _hover: {
                bg: 'brand.600',
                transform: 'translateY(-1px)',
                boxShadow: '0px 4px 12px rgba(105, 120, 153, 0.4)',
              },
              _active: {
                bg: 'brand.700',
                transform: 'translateY(0px)',
              },
            };
          }
          if (c === 'anduril') {
            return {
              bg: 'anduril.500',
              color: 'white',
              _hover: {
                bg: 'anduril.600',
                transform: 'translateY(-1px)',
                boxShadow: '0px 4px 12px rgba(168, 150, 112, 0.4)',
              },
              _active: {
                bg: 'anduril.700',
                transform: 'translateY(0px)',
              },
            };
          }
          if (c === 'executive') {
            return {
              bg: 'executive.500',
              color: 'white',
              _hover: {
                bg: 'executive.600',
                transform: 'translateY(-1px)',
                boxShadow: '0px 4px 12px rgba(231, 113, 24, 0.4)',
              },
              _active: {
                bg: 'executive.700',
                transform: 'translateY(0px)',
              },
            };
          }
          return {};
        },
        outline: (props: any) => {
          const { colorScheme: c } = props;
          if (c === 'brand') {
            return {
              border: '1px solid',
              borderColor: 'brand.500',
              color: 'brand.500',
              bg: 'transparent',
              _hover: {
                bg: 'brand.50',
                borderColor: 'brand.600',
                color: 'brand.600',
                transform: 'translateY(-1px)',
              },
              _active: {
                bg: 'brand.100',
                transform: 'translateY(0px)',
              },
            };
          }
          return {};
        },
        ghost: (props: any) => {
          const { colorScheme: c } = props;
          if (c === 'brand') {
            return {
              color: 'brand.500',
              bg: 'transparent',
              _hover: {
                bg: 'brand.50',
                color: 'brand.600',
              },
              _active: {
                bg: 'brand.100',
              },
            };
          }
          return {};
        },
        subtle: (props: any) => ({
          bg: mode('secondaryGray.100', 'secondaryGray.700')(props),
          color: mode('secondaryGray.700', 'secondaryGray.100')(props),
          _hover: {
            bg: mode('secondaryGray.200', 'secondaryGray.600')(props),
            transform: 'translateY(-1px)',
          },
          _active: {
            bg: mode('secondaryGray.300', 'secondaryGray.500')(props),
            transform: 'translateY(0px)',
          },
        }),
      },
      sizes: {
        lg: {
          h: '48px',
          minW: '48px',
          fontSize: 'md',
          px: '24px',
        },
        md: {
          h: '40px',
          minW: '40px',
          fontSize: 'sm',
          px: '16px',
        },
        sm: {
          h: '32px',
          minW: '32px',
          fontSize: 'xs',
          px: '12px',
        },
      },
    },
  },
}; 